var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolymorphicCapital = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 48,
    viewBox: "0 0 189 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_1149)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_310_1149",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 9,
    width: 124,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157 9H33V39H157V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_310_1149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5828 9.46973C39.5887 9.46973 33.1074 15.9523 33.1074 23.961C33.1074 31.9567 39.5887 38.4523 47.5958 38.4523C55.5899 38.4523 62.0842 31.9697 62.0842 23.961C62.0712 15.9523 55.5899 9.46973 47.5828 9.46973ZM56.5679 32.948H38.5976V14.9741H56.5679V32.948Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6632 22.6175C82.4931 22.6175 84.2014 20.5436 84.2014 17.974C84.2014 15.4045 82.5061 13.3306 79.6632 13.3306C76.8333 13.3306 75.125 15.4045 75.125 17.974C75.125 20.5436 76.8333 22.6175 79.6632 22.6175ZM79.6632 14.8827C81.3976 14.8827 82.4409 16.2653 82.4409 17.974C82.4409 19.6827 81.3976 21.0653 79.6632 21.0653C77.9288 21.0653 76.8855 19.6827 76.8855 17.974C76.8855 16.2653 77.9288 14.8827 79.6632 14.8827Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.838 17.974C118.838 15.4045 117.143 13.3306 114.3 13.3306C111.47 13.3306 109.762 15.4045 109.762 17.974C109.762 20.5436 111.457 22.6175 114.3 22.6175C117.143 22.6175 118.838 20.5436 118.838 17.974ZM114.313 21.0784C112.579 21.0784 111.535 19.6958 111.535 17.9871C111.535 16.2784 112.579 14.8958 114.313 14.8958C116.047 14.8958 117.091 16.2784 117.091 17.9871C117.091 19.6958 116.047 21.0784 114.313 21.0784Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9693 20.9742H86.8875V13.4351H85.127V22.5133H90.9693V20.9742Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.39 17.2046H138.126V13.4351H136.365V22.5133H138.126V18.7568H142.39V22.5133H144.151V13.4351H142.39V17.2046Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.332 13.4351H145.584V22.5133H147.332V13.4351Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2566 19.2133H71.3953C73.534 19.2133 74.7207 17.8698 74.7207 16.3307C74.7207 14.7916 73.7427 13.4351 71.1866 13.4351H67.4961V22.5133H69.2436V19.2133H69.2566ZM69.2566 14.9872H71.3823C72.3734 14.9872 72.9732 15.509 72.9732 16.3829C72.9732 17.1655 72.3864 17.7785 71.3823 17.7785H69.2566V14.9872Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.009 13.4351H128.318V22.5133H130.079V19.2133H132.218C134.356 19.2133 135.543 17.8698 135.543 16.3307C135.543 14.7916 134.565 13.4351 132.009 13.4351ZM132.205 17.7785H130.079V14.9872H132.205C133.196 14.9872 133.795 15.509 133.795 16.3829C133.795 17.1655 133.196 17.7785 132.205 17.7785Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.989 16.3304C126.989 14.7782 126.011 13.4478 123.455 13.4478H119.777V22.526H121.525V19.213H123.637L125.281 22.513H127.132L125.189 18.9391C126.363 18.4695 126.989 17.4521 126.989 16.3304ZM121.525 14.9869H123.651C124.642 14.9869 125.242 15.5086 125.242 16.3825C125.242 17.1652 124.655 17.7782 123.651 17.7782H121.525V14.9869Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.784 21.0785C151.036 21.0785 150.019 19.6959 150.019 17.9872C150.019 16.2785 151.023 14.8959 152.784 14.8959C154.335 14.8959 155.079 15.9655 155.196 16.8524H156.931C156.813 15.3394 155.574 13.3438 152.758 13.3438C149.902 13.3438 148.271 15.4177 148.271 17.9872C148.271 20.5568 149.902 22.6307 152.758 22.6307C155.574 22.6307 156.813 20.6351 156.931 19.122H155.196C155.079 20.009 154.322 21.0785 152.784 21.0785Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2128 13.4351L93.5394 18.1829L90.8791 13.4351H89.0273L92.6657 19.5525V22.5133H94.4262V19.5525L98.0776 13.4351H96.2128Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.138 14.5829L102.368 22.5133H104.859L107.089 14.5829V22.5133H108.849V13.4351H105.798L103.62 21.1959L101.429 13.4351H98.3906V22.5133H100.138V14.5829Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.204 25.396H111.418V34.4351H117.704V32.896H113.204V25.396Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.55 25.3696H95.2207V26.9088H97.9984V34.4088H99.785V26.9088H102.55V25.3696Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4507 25.3696H92.6641V34.4218H94.4507V25.3696Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3748 25.396H84.6973V34.4482H86.4447V31.1612H88.5834C90.7221 31.1612 91.8958 29.8177 91.8958 28.2786C91.8958 26.7264 90.9177 25.396 88.3748 25.396ZM88.5704 29.7134H86.4447V26.9351H88.5704C89.5615 26.9351 90.1483 27.4438 90.1483 28.3177C90.1483 29.1134 89.5615 29.7134 88.5704 29.7134Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.151 25.4219L74.8125 34.448H76.8078L77.512 32.3871H81.3329L82.0371 34.448H84.0324L80.6548 25.4219H78.151ZM77.9814 30.9654L79.4159 26.7784L80.8504 30.9654H77.9814Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.793 25.3696L101.455 34.3957H103.45L104.154 32.3348H107.975L108.68 34.3957H110.675L107.31 25.3696H104.793ZM104.624 30.9131L106.058 26.7261L107.493 30.9131H104.624Z",
    fill: "#535660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8599 26.8437C72.4117 26.8437 73.1551 27.9132 73.2724 28.8002H75.0069C74.8895 27.2872 73.6506 25.2915 70.8338 25.2915C67.9778 25.2915 66.3477 27.3654 66.3477 29.935C66.3477 32.5045 67.9778 34.5785 70.8338 34.5785C73.6506 34.5785 74.8895 32.5828 75.0069 31.0698H73.2724C73.1551 31.9567 72.4117 33.0263 70.8599 33.0263C69.1124 33.0263 68.0952 31.6437 68.0952 29.935C68.0952 28.2132 69.1124 26.8437 70.8599 26.8437Z",
    fill: "#535660"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_1149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 30,
    fill: "white",
    transform: "translate(33 9)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolymorphicCapital);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/polymorphic_capital.3b80630d63e98077bf1bbd07167bd267.svg";